import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-4" }, "ユーザ編集")
], -1)
const _hoisted_3 = { class: "mt-5 justify-content-center" }
const _hoisted_4 = { class: "d-flex justify-content-center my-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success mx-2 mb-2"
}, "更新", -1)

import { ref } from 'vue'
import { AccountStatusType, Municipality, useNicotto, User } from '@/plugins/nicotto'
import UserPage from "@/components/forms/UserPage.vue";
import { useMessenger } from '@/plugins/message'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditView',
  props: {
    userId: null
  },
  setup(__props: any) {

const props = __props as {
  userId: string
}



const user = ref<User>(new User(props.userId, {}))
const status = ref<AccountStatusType>()
const nicotto = useNicotto()
const messenger = useMessenger()
const router = useRouter()
let email = ""
nicotto.account.getUser(props.userId)
  .then(data => {
    if (!data.municipality) {
      console.error('自治体情報が存在しません。')
      messenger.set('user.getDataFailed')
    }
    user.value = data
    email = data.email
    status.value = data.status()
  })
  .catch(() => {
    // Cognitoデータ取得エラー等
    messenger.set('user.getDataFailed')
  })

const updateStatus = async(newStatus: AccountStatusType, user: User, municipality: Municipality) => {
  switch (newStatus) {
        case 'enabled':
          await nicotto.account.acceptMunicipality(municipality, ['concierge'])
          if (user.status() == 'disabled') {
            await nicotto.account.enableUser(user.userId)
          }
          break
        case 'disabled':
          await nicotto.account.disableUser(user.userId)
          break
        case 'notAccepted':
          await nicotto.account.cancelMunicipality(municipality)
          if (user.status() == 'disabled') {
            await nicotto.account.enableUser(user.userId)
          }
          break
      }
}

const save = async() => {
  try {
    if (email !== user.value.email) {
      await nicotto.account.updateUserEmail(props.userId, user.value.email, true)
      email = user.value.email
    }
    await nicotto.account.updateAccount(user.value)
    if (status.value && status.value !== user.value.status()) {
      await updateStatus(status.value, user.value, user.value.municipality as Municipality)
    }
    messenger.set('user.updateSucceeded')
    router.push('/users')
  } catch (err: any) {
    if (err?.errors?.filter((e: any) => e.message.indexOf('already exists') !== -1).length > 0) {
      messenger.set('user.saveFailedAlreadyExists')
    } else {
      messenger.set('user.updateFailed')
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(UserPage, {
        user: user.value,
        "onUpdate:user": _cache[0] || (_cache[0] = ($event: any) => ((user).value = $event)),
        municipality: user.value.municipality,
        "onUpdate:municipality": _cache[1] || (_cache[1] = ($event: any) => ((user.value.municipality) = $event)),
        status: status.value,
        "onUpdate:status": _cache[2] || (_cache[2] = ($event: any) => ((status).value = $event)),
        "is-admin": true,
        onSubmit: save
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/users",
              class: "btn btn-secondary mx-2 mb-2",
              role: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6
          ])
        ]),
        _: 1
      }, 8, ["user", "municipality", "status"])
    ])
  ]))
}
}

})